export default {
    ACCOUNT_RECEIVABLE: 'A_R',
    UNEARNED_REVENUE: 'UNEARN_REV',
    EXPENSE: 'EXPENSE',
    TAX: 'TAX'
}